<template>
  <view-wrapper
    backText="Go to order list"
    prefix="Create new"
    name="Order"
    path="orders"
    :showCancel="true"
    addedText="Send to assigned groups"
    :addedFunc="createOrder"
    :validation="validation"
    :hasChangesBeenMade="hasChangesBeenMade"
    :loading="loading"
  >
    <wrapper class="mb-5" :checkForChildFocused="true">
      <grafokett-input
        v-model="orderNumber"
        type="text"
        labelPlaceholder="Order number"
        :editable="true"
      />
    </wrapper>

    <wrapper class="mb-5">
      <div class="flex items-center justify-between">
        <p>Order data</p>
        <button
          class="flex items-center px-4 py-2 font-bold bg-transparent border-solid rounded-lg cursor-pointer border-highlight text-highlight"
          type="button"
          @click="addOrderData"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5 mr-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
              clip-rule="evenodd"
            />
          </svg>
          Add
        </button>
      </div>
      <div class="flex flex-col mt-6">
        <div
          class="grid grid-cols-5 gap-2"
          v-for="(data, index) in orderData"
          :key="index"
        >
          <grafokett-input
            v-model="data.key"
            :editable="true"
            type="text"
            labelPlaceholder="Key"
            class="col-span-1"
          />
          <div class="flex col-span-4 gap-4">
            <grafokett-input
              v-model="data.data"
              :editable="true"
              type="text"
              class="flex-1 ml-4"
              labelPlaceholder="Data"
              :is-expandable="true"
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="self-center w-6 h-6 cursor-pointer text-highlight"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              @click="removeOrderData(index)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </div>
        </div>
      </div>
    </wrapper>

    <wrapper :focus="addedArticles.length > 0" class="articels">
      <div
        v-if="addedArticles && addedArticles.length > 0"
        class="added-articels"
      >
        <p>Articles in this order</p>
        <GenericAccordion
          :columnsToNotSort="columnsToNotSort"
          :types="types"
          :headers="addedArticlesHeaders"
          :data="addedArticles"
          :useSearch="false"
          @buttonClicked="removeArticle"
        ></GenericAccordion>
        <br />
      </div>
      <div v-show="!articlesLockedIn">
        <p>Add articles to order</p>
        <p v-if="articles && articles.length === 0">No matching articles</p>
        <p v-if="!articles">Loading articles...</p>
        <GenericAccordion
          :columnsToNotSort="columnsToNotSort"
          :types="types"
          :headers="headers"
          :data="articles"
          :useSearch="true"
          @searchQuery="handleSearch"
          @buttonClicked="addArticle"
        ></GenericAccordion>
      </div>
    </wrapper>

    <div class="my-5 text-right">
      <grafokett-button
        class="big primary"
        @click="lockInArticles"
        :class="{ disable: !(addedArticles && addedArticles.length > 0) }"
        >{{ articlesLockedIn ? "Edit" : "Ok" }}</grafokett-button
      >
    </div>

    <assign-groups :groups="groups" v-model="parentGroup" />

    <div class="my-5 text-right">
      <grafokett-button
        class="big primary"
        @click="lockInGroups"
        :class="{ disable: !(parentGroup && parentGroup.length > 0) }"
        >{{ groupsLockedIn ? "Edit" : "Ok" }}</grafokett-button
      >
    </div>
  </view-wrapper>
</template>

<script>
import GrafokettButton from "../components/forms/Button.vue";
import GrafokettInput from "../components/forms/Input.vue";
import GenericAccordion from "../components/GenericAccordion";
import AssignGroups from "../components/datacomponents/AssignGroups";

export default {
  components: {
    GrafokettButton,
    GrafokettInput,
    GenericAccordion,
    AssignGroups,
  },
  data() {
    return {
      orderNumber: "",
      showPopUp: false,
      addedArticles: [],
      articles: null,
      parentGroup: [],
      articlesLockedIn: false,
      groupsLockedIn: false,
      orderData: [],
      addedArticlesHeaders: {
        article: "Article name",
        quantity: "Maxumum print quantity",
        remove: "",
      },
      headers: {
        article: "Article name",
        quantity: "Maxumum print quantity",
        add: "",
      },
      columnsToNotSort: ["quantity", "add", "remove"],
      types: {
        article: { type: "string" },
        quantity: { type: "number-input" },
        add: { type: "button", classes: "small", textAlign: "right" },
        remove: { type: "button", classes: "small", textAlign: "right" },
      },
      loading: false,
    };
  },
  methods: {
    hasChangesBeenMade() {
      return (
        this.orderNumber !== "" ||
        this.addedArticles.length > 0 ||
        this.parentGroup.length > 0
      );
    },
    validation() {
      return this.groupsLockedIn && this.articlesLockedIn && this.orderNumber;
    },
    async getData() {
      this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
      await this.searchArticles("", 1, 10);
    },
    async searchArticles(searchQuery, page, pageSize) {
      this.articles = null;
      const response = await this.$store.$api.get(
        `/api/articles?take=${pageSize}&offset=${pageSize *
          (page - 1)}&searchQuery=${searchQuery}`
      );
      this.articles = response.data.data
        .map(a => {
          return {
            article: a.name,
            quantity: "80",
            add: "Add",
            remove: "Remove",
            id: a.id,
          };
        })
        .filter(a => !this.addedArticles.find(x => x.id === a.id));
    },
    async handleSearch(value) {
      await this.searchArticles(value, 1, 1000);
    },
    addArticle(e) {
      if (e.button === "add") {
        let match = undefined;
        for (let i = 0; i < this.articles.length; i++) {
          if (this.articles[i] === e.data) {
            this.addedArticles.push(e.data);
            match = i;
          }
        }
        if (match !== undefined) {
          this.articles.splice(match, 1);
        }
      }
    },
    removeArticle(e) {
      if (e.button === "remove") {
        let match = undefined;
        for (let i = 0; i < this.addedArticles.length; i++) {
          if (this.addedArticles[i] === e.data) {
            this.articles.push(e.data);
            match = i;
          }
        }
        if (match !== undefined) {
          this.addedArticles.splice(match, 1);
          this.articlesLockedIn = false;
        }
      }
    },
    addParentGroup(group) {
      if (this.doseGroupeExist(group, this.parentGroup)) return;
      const i = this.parentGroup.indexOf(group);
      if (i === -1 && !this.doseGroupeExist(group, this.parentGroup)) {
        this.parentGroup.push(group);
        this.removeChildGroups(group);
      }
    },
    removeChildGroups(group) {
      if (group.children) {
        for (let i = 0; i < group.children.length; i++) {
          this.removeChildGroups(group.children[i]);
          this.removeParentGroup(group.children[i]);
        }
      }
    },
    removeParentGroup(group) {
      const i = this.parentGroup.indexOf(group);
      if (i !== -1) {
        this.parentGroup.splice(i, 1);
        this.groupsLockedIn = false;
      }
    },
    doseGroupeExist(group, children) {
      if (!children) return false;
      let exists = children.includes(group);
      if (exists) return true;
      for (let i = 0; i < children.length; i++) {
        if (this.doseGroupeExist(group, children[i].children)) return true;
      }
    },
    groupClass(group) {
      return { "added-tree-item": this.parentGroup.indexOf(group) !== -1 };
    },
    lockInGroups() {
      if (this.parentGroup.length > 0)
        this.groupsLockedIn = !this.groupsLockedIn;
    },
    lockInArticles() {
      if (this.addedArticles.length > 0)
        this.articlesLockedIn = !this.articlesLockedIn;
    },
    async createOrder() {
      this.loading = true;
      const payload = {
        orderReference: this.orderNumber,
        articles: this.addedArticles.map(a => {
          return {
            articleId: a.id,
            maxQuantity: parseInt(a.quantity, 10),
          };
        }),
        groups: this.parentGroup.map(a => a.id),
        orderData: this.orderData,
      };
      try {
        await this.$store.$api.post("/api/orders", payload);
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
        throw error;
      }

      await this.$router.push({ name: "orders" });
    },
    addOrderData() {
      this.orderData.push({ key: "", data: "" });
    },
    removeOrderData(index) {
      this.orderData.splice(index, 1);
    },
  },
  computed: {
    groups() {
      return this.$store.getters["GROUPS/GROUPS"];
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
